import type React from "react";
import { Box } from "@mui/material";
import FuneralPreviewCard from "../components/FuneralPreviewThumbnail";
import youtube_logo from "../../../../assets/Youtube_logo.png";

interface StreamThumbnailProps {
  firstName: string;
  lastName: string;
  birthDate: string;
  deathDate: string;
  serviceDate: string;
  serviceTime: string;
  location: string;
}

const StreamThumbnail: React.FC<StreamThumbnailProps> = ({
  firstName,
  lastName,
  birthDate,
  deathDate,
  serviceDate,
  serviceTime,
  location,
}) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Box
        sx={{
          position: "relative",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: "680px",
            borderRadius: "12px",
            overflow: "hidden",
            position: "relative",
          }}
        >
          <FuneralPreviewCard
            deceasedName={`${firstName} ${lastName}`}
            birthDate={birthDate}
            deathDate={deathDate}
            serviceDate={serviceDate}
            serviceTime={serviceTime}
            timeZone="CAT"
            location={location}
            isLiveStream={true}
            broadcastBy="MUZUKURU"
          />

          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.45)",
              zIndex: 10,
            }}
          />

          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 20,
              width: "100px",
              height: "90px",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              component="img"
              src={youtube_logo}
              alt="Play"
              sx={{
                width: "60px",
                height: "55px",
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default StreamThumbnail;
